import ModusServiceCollection from "../ModusServiceCollection";
import ResultNutrientRecommendationModel from "../../models/modus/ResultNutrientRecommendationModel";

/**
 * ResultNutrientRecommendation collection
 */
export default class ResultNutrientRecommendationCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ResultNutrientRecommendationModel;
  }

}
